import toast, { ToastOptions } from 'react-hot-toast';

export const WARNING_CLASS = 'toast-warning';

export const cutToast = Object.assign(toast, {
  info: (...args: Parameters<typeof toast>) => toast(...args),
  warning: (message: Parameters<typeof toast>[0], opts?: ToastOptions) =>
    toast(message, {
      duration: 6000,
      ...opts,
      className: [WARNING_CLASS, opts?.className].filter(Boolean).join(' '),
    }),
});
